<template>
  <div id="home-page">
  <loading-component v-if="isLoading"></loading-component>
    <div class="page-content" v-if="!isLoading">
      <div class="content band">
          <div class="container tagline">
              <p>Web Design, Web Development,<br /> Video Production, and Motion Graphics.</p>
          </div>
      </div>
      <div class="mini-band">
          <div class="container">
            <div class="view-controls d-flex flex-md-row justify-content-between">
              <ul class="item-sort-controls" data-field="field_id">
                <li class="item-sort-control">
                  <b>Filter:</b>
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 0 ? 'current' : ''" v-on:click="setCurrentFilter('All', 0)">
                  All
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 1 ? 'current' : ''" v-on:click="setCurrentFilter('Web Development', 1)">
                  Web Development
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 2 ? 'current' : ''" v-on:click="setCurrentFilter('Web Design', 2)">
                  Web Design
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 3 ? 'current' : ''" v-on:click="setCurrentFilter('Graphic Design', 3)">
                  Graphic Design
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 4 ? 'current' : ''" v-on:click="setCurrentFilter('Video Production', 4)">
                  Video Production
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 5 ? 'current' : ''" v-on:click="setCurrentFilter('Motion Graphics', 5)">
                  Motion Graphics
                </li>
                <li class="item-sort-control" :class="currentFilterIndex === 6 ? 'current' : ''" v-on:click="setCurrentFilter('Photography', 6)">
                  Photography
                </li>
              </ul>
              <div class="view-control-icons">
                <img v-if="itemViewType == 'grid'" v-on:click="toggleView()" class="view-control-icon" src="static/img/list-icon.svg" style="width: 20px; height: 20px;" />
                <img v-if="itemViewType == 'full'" v-on:click="toggleView()" class="view-control-icon" src="static/img/grid-icon.svg" style="width: 20px; height: 20px;" />
              </div>
            </div>
          </div>
      </div>
      <main role="main" class="container">
          <h1>{{ this.currentFilterValue }} Projects:</h1>
          <div v-if="itemViewType == 'full'" class="full-item-view" v-for="project in filtered" :key="project.projectId">
              <div class="item">
                  <div class="item-title d-flex flex-md-row justify-content-between">
                      <div class="title">
                          <p>{{ project.projectName }}</p>
                      </div>
                      <div class="item-button">
                          <router-link :to="{ name: 'ProjectDetailPage', params: { id: project.projectId, name: project.projectNameUrlSafe } }">View Project Details</router-link>
                      </div>
                  </div>
                  <div class="item-image">
                      <router-link :to="{ name: 'ProjectDetailPage', params: { id: project.projectId, name: project.projectNameUrlSafe } }">
                          <img class="img-fluid" :src="project.projectMainImage" />
                      </router-link>
                  </div>
              </div>
          </div>
          <div v-if="itemViewType == 'grid'" class="grid-item-view">
              <div class="album py-5">
                  <div class="container">
                      <div class="row" v-for="(i, index) in rowCount" :key="index">
                          <div class="grid-item col-md-6" v-for="(project, index) in projectCountInRow(i)" :key="index">
                              <div class="card mb-6">
                                  <div class="card-body">
                                    <p class="card-title">{{ project.projectName }}</p>
                                  </div>
                                  <router-link :to="{ name: 'ProjectDetailPage', params: { id: project.projectId, name: project.projectNameUrlSafe } }">
                                    <img class="img-fluid" :src="project.projectMainImage" />
                                  </router-link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </main>
    </div>
  </div>
</template>

<script>
import LoadingComponent from '../components/LoadingComponent'
import axios from 'axios'

export default {
  name: 'HomePage',
  components: {
    LoadingComponent
  },
  data: () => {
    return {
      isLoading: true,
      itemViewType: 'full',
      filteredProjects: [],
      currentFilterValue: 'All',
      currentFilterIndex: 0,
      projects: null,
      projectsPerRow: 2
    }
  },
  created () {
    this.checkPreferences()
    this.fetchProjectData()

    let self = this
    setTimeout(function () {
      self.isLoading = false
    }, 1000)
  },
  computed: {
    rowCount: function () {
      return Math.ceil(this.projects.length / this.projectsPerRow)
    },
    filtered: function () {
      if (this.currentFilterValue === 'All') {
        return this.projects
      } else {
        return this.projects.filter(project => project.projectTags.includes(this.currentFilterValue))
      }
    }
  },
  methods: {
    toggleView: function () {
      if (this.itemViewType === 'full') {
        this.itemViewType = 'grid'
        this.updateUserPreferences()
        return true
      }
      if (this.itemViewType === 'grid') {
        this.itemViewType = 'full'
        this.updateUserPreferences()
        return true
      }
    },
    setCurrentFilter: function (filter, index) {
      this.currentFilterValue = filter
      this.currentFilterIndex = index
    },
    fetchProjectData: function () {
      axios.get('./static/projects.json').then((response) => {
        response.data.sort(function (a, b) { return a['sortOrder'] - b['sortOrder'] })
        this.projects = response.data
      }, (error) => {
        console.log(error)
      })
    },
    projectCountInRow: function (index) {
      return this.filtered.slice((index - 1) * this.projectsPerRow, index * this.projectsPerRow)
    },
    checkPreferences: function () {
      if (!localStorage.getItem('viewtype')) {
        this.setDefaultPreferences()
      } else {
        this.getUserPreferences()
      }
    },
    setDefaultPreferences: function () {
      this.itemViewType = 'grid'
    },
    getUserPreferences: function () {
      this.itemViewType = localStorage.getItem('viewtype')
    },
    updateUserPreferences: function () {
      localStorage.setItem('viewtype', this.itemViewType)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue